export type TenantContextInput = {
  brandId?: string | null;
  tenantCode?: string | null;
};

export type SelectOption = {
  value: string;
  label?: string;
};

export function isZuuTenantContext(input: TenantContextInput): boolean {
  return input.brandId === "zuu" || input.tenantCode === "zuu";
}

export function getGenderFromSalutation(
  salutation: string | undefined,
  context: TenantContextInput = {},
): string | undefined {
  if (!salutation) {
    return undefined;
  }

  if (isZuuTenantContext(context)) {
    if (salutation === "MALE") {
      return "MALE";
    }

    if (
      salutation === "FEMALE" ||
      salutation === "MRS" ||
      salutation === "MISS"
    ) {
      return "FEMALE";
    }

    return undefined;
  }

  if (salutation === "MR" || salutation === "MALE") {
    return "MALE";
  }

  if (
    salutation === "MS" ||
    salutation === "MRS" ||
    salutation === "MISS" ||
    salutation === "FEMALE"
  ) {
    return "FEMALE";
  }

  return undefined;
}

export function shouldAutoFillSalutationFromGender(
  context: TenantContextInput = {},
): boolean {
  return !isZuuTenantContext(context);
}

export function getSalutationFromGenderByContext(
  gender: string | undefined,
  salutationOptions: SelectOption[],
  context: TenantContextInput = {},
): string | undefined {
  if (!gender || !shouldAutoFillSalutationFromGender(context)) {
    return undefined;
  }

  if (gender === "MALE") {
    return salutationOptions.some((opt) => opt.value === "MR") ? "MR" : "MALE";
  }

  if (gender === "FEMALE") {
    return salutationOptions.some((opt) => opt.value === "MS") ? "MS" : "FEMALE";
  }

  return undefined;
}
